import { useMemo } from "react";

export const useIsUrlValid = (urlString) => {
  return useMemo(() => {
    if (typeof urlString !== "string") return false;

    try {
      const url = new URL(urlString);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch {
      return false;
    }
  }, [urlString]);
};
